// extracted by mini-css-extract-plugin
module.exports = {"root":"IconArrow_root__1xjte"};